import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import IconBase, { IconBaseProps } from "@/components/ui/Form/Filters/components/Icon/IconBase";

export interface IconControlledProps extends IconBaseProps {
  control: Control;
}
const IconControlled: FC<IconControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <IconBase field={field} fieldState={fieldState} {...rest} />;
};
export default IconControlled;
